import { z } from "zod";

// Schema for the SalesCategory model
const SalesCategorySchema = z
  .object({
    salesCategoryId: z.number().nullable().optional().readonly(),
    // TODO: Reinstate .uuid() validation once mock data or server-side generation provides valid UUIDs.
    guid: z.string().nullable().optional().readonly(),
    number: z.number().nullable().optional().readonly(),
    name: z
      .string()
      .min(1, { message: "Sales category name cannot be empty" })
      .readonly(),
    description: z.string().nullable().optional().readonly(),
    code: z
      .string()
      .min(1, { message: "Sales category code cannot be empty" })
      .max(4, { message: "Sales category code cannot exceed 4 characters" })
      .readonly(), // Assuming code is required
    color: z
      .string()
      .regex(/^#[0-9A-Fa-f]{6}$/, { message: "Color must be a hex value (e.g. #0ea5e9)" })
      .nullable()
      .optional()
      .readonly(),
    isArchived: z.boolean().nullable().optional().readonly(), // Soft delete flag
    createdAt: z.date().nullable().optional().readonly(), // Firestore server timestamp
    updatedAt: z.date().nullable().optional().readonly(), // Firestore server timestamp
    archivedAt: z.date().nullable().optional().readonly(), // Timestamp when archived
  })
  .strict();

export type SalesCategoryType = z.infer<typeof SalesCategorySchema>;

export default SalesCategorySchema;
